// src/pages/Dashboard/components/ChatPanel/ChatInput.js - CORREÇÃO

import React from 'react';

/**
 * Input de mensagem do chat
 * @param {string} value - Valor atual do input
 * @param {function} onChange - Callback ao mudar valor
 * @param {function} onSend - Callback ao enviar mensagem
 * @param {boolean} disabled - Se está desabilitado
 */
const ChatInput = ({ value, onChange, onSend, disabled }) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      // CORREÇÃO: Chamar onSend sem parâmetros
      onSend();
    }
  };

  const handleChange = (e) => {
    // CORREÇÃO: Garantir que passamos string para onChange
    const newValue = e.target.value || '';
    onChange(newValue);
  };

  const handleSend = () => {
    // CORREÇÃO: Chamar onSend sem parâmetros
    onSend();
  };

  return (
    <div className="chat-input-dashboard">
      <textarea
        className="message-input-dashboard"
        value={value || ''} // CORREÇÃO: Garantir que value nunca é undefined
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        placeholder="Pergunte sobre o caso jurídico..."
        rows={2}
        disabled={disabled}
      />
      <button 
        className="send-btn-dashboard"
        onClick={handleSend}
        disabled={!value || !value.trim() || disabled} // CORREÇÃO: Validar antes de usar trim
      >
        ➤
      </button>
    </div>
  );
};

export default ChatInput;